import { render } from "./MessageDetail.vue?vue&type=template&id=093f92b9&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"

import "./MessageDetail.scss?vue&type=style&index=0&id=093f92b9&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093f92b9"]])

export default __exports__